import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-plaid-auth',
  templateUrl: './plaid-auth.component.html',
  styleUrls: ['./plaid-auth.component.css']
})
export class PlaidAuthComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
